// extracted by mini-css-extract-plugin
export default {"overall":"OverallLayout_overall__KiXoi"};